import MaintainCustomer from './MaintainCustomer.vue';

export default MaintainCustomer;


// WEBPACK FOOTER //
// ./src/components/MaintainCustomer/index.js